import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { TIER_BANDS, fmtWhen } from "./labels";

const TIERS = ["Basic", "Mid-range", "Comfort", "Luxury"];
export const fmtRange = (lo, hi) => (lo == null ? "—" : hi == null ? `$${Math.round(lo)}+` : `$${Math.round(lo)}–${Math.round(hi)}`);

function TierTable({ rows, pax, testid }) {
  const dests = [...new Set(rows.filter((r) => r.pax === pax).map((r) => r.destination))];
  if (!dests.length) return null;
  const cell = (dest, tier) => rows.find((r) => r.destination === dest && r.pax === pax && r.tier === tier);
  return (
    <table className="w-full text-[12px]" data-testid={testid}>
      <thead><tr className="text-left text-clay-600">
        <th className="py-1.5 pr-3 font-medium">{pax === "solo" ? "Viajero solo" : "2 o más viajeros"}</th>
        {TIERS.map((t) => <th key={t} className="py-1.5 pr-3 font-medium">{TIER_BANDS[t]}</th>)}
      </tr></thead>
      <tbody>
        {dests.map((d) => (
          <tr key={d} className="border-t border-clay-200">
            <td className="py-1.5 pr-3 font-medium">{d}</td>
            {TIERS.map((t) => {
              const r = cell(d, t);
              return (
                <td key={t} className="py-1.5 pr-3 tabular align-top">
                  {r ? <>
                    <div>{fmtRange(r.per_day_lo, r.per_day_hi)}<span className="text-clay-500"> · {r.leads} leads</span></div>
                    {r.earlier.map((e, i) => <div key={i} className="text-[10px] text-clay-500">antes {fmtRange(e.per_day_lo, e.per_day_hi)} ({e.from.slice(5)}→{e.to.slice(5)})</div>)}
                  </> : <span className="text-clay-400">—</span>}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function BudgetTiers() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  useEffect(() => { if (open && !data) api.get("/kimkim/budget-tiers").then(({ data: d }) => setData(d)).catch(() => {}); }, [open, data]);
  const mins = Object.entries(data?.min_daily_budget || {});
  return (
    <section className="border border-clay-300 bg-white" data-testid="kimkim-budget-tiers">
      <button onClick={() => setOpen(!open)} className="w-full text-left px-5 py-3 flex items-center gap-2 hover:bg-clay-50" data-testid="kimkim-budget-tiers-toggle">
        {open ? <ChevronDown size={14}/> : <ChevronRight size={14}/>}
        <span className="smallcaps">Categorías de presupuesto de KimKim por país</span>
        <span className="text-[11px] text-clay-500 ml-auto">USD por persona y día · lo que ve el viajero al pedir el viaje</span>
      </button>
      {open && (
        <div className="border-t border-clay-200 px-5 py-4 space-y-4">
          {!data ? <div className="text-sm text-clay-600">Cargando…</div> : <>
            <p className="text-[12px] text-clay-700 max-w-3xl">
              KimKim no publica esta tabla en el portal de la agencia: la deducimos de las propias solicitudes (“Basic, around $4.200 – $5.280 por persona” ÷ días del viaje) de {data.leads_with_range} leads. Cuando KimKim cambia los rangos, aparece el valor anterior en gris con los meses en que estuvo vigente.
            </p>
            <TierTable rows={data.tiers} pax="2+" testid="kimkim-tiers-couple"/>
            <TierTable rows={data.tiers} pax="solo" testid="kimkim-tiers-solo"/>
            {mins.length > 0 && (
              <div className="text-[12px]" data-testid="kimkim-min-budget">
                <span className="smallcaps">Mínimo diario que tenemos puesto en KimKim</span>
                <span className="text-clay-500 text-[10px] ml-2">(Company profile → Trip budget · leído {fmtWhen(data.min_daily_budget_at)})</span>
                <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 tabular">
                  {mins.map(([k, v]) => <span key={k}>{k}: <strong>{v == null ? "sin mínimo" : `$${v}`}</strong></span>)}
                </div>
              </div>
            )}
          </>}
        </div>
      )}
    </section>
  );
}
